import { render, staticRenderFns } from "./game-group-form-items.vue?vue&type=template&id=8766fb42&scoped=true"
import script from "./game-group-form-items.vue?vue&type=script&setup=true&lang=js"
export * from "./game-group-form-items.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8766fb42",
  null
  
)

export default component.exports